export const downloadReport = async (
  downloadFn: () => Promise<Blob>,
  fileName: string,
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  setLoading?: (loading: boolean) => void
) => {
  if (setLoading) setLoading(true);
  try {
    const blob = await downloadFn();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    onSuccess(`${fileName.replace(/_/g, " ").replace(".xlsx", "")} downloaded successfully!`);
  } catch (error: any) {
    console.error("Download error:", error);
    onError(error?.response?.data?.message || "Failed to download report");
  } finally {
    if (setLoading) setLoading(false);
  }
};
